import { render, staticRenderFns } from "./siderRightOptions.vue?vue&type=template&id=70749186&scoped=true&"
import script from "./siderRightOptions.vue?vue&type=script&lang=js&"
export * from "./siderRightOptions.vue?vue&type=script&lang=js&"
import style0 from "./siderRightOptions.vue?vue&type=style&index=0&id=70749186&lang=scss&scoped=true&"
import style1 from "./siderRightOptions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70749186",
  null
  
)

export default component.exports